module.exports = "fragment PhoneNumberCountryFragment on PhoneNumberCountry {\n  name\n  isoCode\n  callingCode\n}\n"